export default "__VITE_ASSET__CtcmOCya__"